import { render } from "./OfxImportWizard.vue?vue&type=template&id=0aea686c&scoped=true"
import script from "./OfxImportWizard.vue?vue&type=script&lang=js"
export * from "./OfxImportWizard.vue?vue&type=script&lang=js"

import "./OfxImportWizard.vue?vue&type=style&index=0&id=0aea686c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aea686c"]])

export default __exports__